import { AnimatePresence, motion } from "framer-motion";

const slideVariants = {
  hidden: { y: -60, opacity: 0 },
  visible: { y: 0, opacity: 1 },
  exit: { y: -60, opacity: 0 },
};

const OfflineBanner = ({ show = true }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed top-0 left-0 right-0 bg-orange-100 text-orange-900 text-center p-2 z-50"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={slideVariants}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          You are currently offline! Please check your internet connection.
        </motion.div>
      )}
    </AnimatePresence>
  );
};

OfflineBanner.propTypes = {
  show: Boolean,
};

export default OfflineBanner;